import SideBarItem from "@components/Common/SideBarItem"
import styles from "./MobileNavigationTab.module.css"

const MobileNavigationTab = () => {
  return (
    <div className={styles.mobileNavigationTabSection}>
      <SideBarItem route="/dashboard" />

      <SideBarItem route="/manage-patient-vision" />

      <SideBarItem route="/manage-appointment" />

      <SideBarItem route="/other-apps" />

      <SideBarItem route="/my-account" />
    </div>
  )
}

export default MobileNavigationTab
